<script>
export default {
  name: "MinionSaveModal",
  props: {
    isVisible: Boolean,
    agentId: [Number, String],
    types: Array,
  },
  data() {
    return {
      selectedType: null,
      isSaving: false,
      errors: {},
    }
  },
  methods: {
    async saveType() {
      this.errors = { }
      this.isSaving = true
      try {
        const { data } = await this.$axios.post("admin/minions", {
          type_id: this.selectedType,
          agent_id: Number(this.agentId),
        })
        console.log(data)
        this.$emit('refresh')
        this.closeDialog()
      } catch (e) {
        this.errors = e.error?.response?.data?.errors ?? {}
        console.error(e)
        throw e
      } finally {
        this.isSaving = false
      }
    },
    closeDialog() {
      this.errors = {}
      this.selectedType = null
      this.$emit("update:isVisible", false)
    },
  },
}
</script>

<template>
  <b-modal :active="isVisible" :width="400" :can-cancel="false" @close="closeDialog">
    <div class="has-background-white-ter p-5">
      <form @submit.prevent="">
        <div class="columns is-flex-wrap-wrap">
          <div class="column">
            <b-field
              label="Type"
              :message="errors && errors['agent_id']"
              :type="errors && errors['agent_id'] && 'is-danger'"
            >
              <b-select v-model="selectedType" expanded>
                <option :value="null">Не выбрано</option>
                <option
                  v-for="type in types"
                  :key="type.id"
                  :value="type.id"
                >
                  {{ type.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-full is-flex is-justify-content-end">
            <b-button
              label="Отмена"
              type="button"
              class="mr-3"
              @click="closeDialog"
            />
            <b-button
              :label="'Сохранить'"
              class="is-info"
              type="submit"
              :disabled="isSaving"
              @click="saveType"
            />
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<style scoped>

</style>
